import { useGateway } from '@ad-lucy/gateway-provider';
import { Button } from '@ad-lucy/ui';
import { useI18n } from '@i18n/i18n.utils';

export function LogoutButton() {
  const { t } = useI18n();
  const gateway = useGateway();
  return (
    <Button onClick={() => gateway.logout()}>
      {t('errorView.general.logout')}
    </Button>
  );
}
